var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteModalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 9.5,
    fill: "#F8F9FB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 49,
    height: 49,
    rx: 9.5,
    stroke: "#FAFBFD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2097 35.3705C18.6218 35.3705 18.1193 35.1619 17.7022 34.7448C17.2849 34.3278 17.0763 33.8252 17.0763 33.237V17.5736H16.7291C16.4866 17.5736 16.2797 17.488 16.1084 17.3167C15.9372 17.1453 15.8516 16.9393 15.8516 16.6989C15.8516 16.4585 15.9372 16.2527 16.1084 16.0814C16.2797 15.9104 16.4866 15.8248 16.7291 15.8248H21.3V15.8092C21.3 15.5265 21.4025 15.2826 21.6075 15.0773C21.8127 14.8721 22.0587 14.7695 22.3456 14.7695H27.6844C27.9673 14.7695 28.2114 14.8721 28.4166 15.0773C28.6216 15.2826 28.7241 15.5265 28.7241 15.8092V15.8248H33.3034C33.5403 15.8248 33.7444 15.9107 33.9156 16.0823C34.0869 16.254 34.1725 16.4588 34.1725 16.6967C34.1725 16.9392 34.0867 17.146 33.915 17.317C33.7435 17.4881 33.5389 17.5736 33.3009 17.5736H32.9475V33.237C32.9475 33.8252 32.739 34.3278 32.3219 34.7448C31.9048 35.1619 31.4023 35.3705 30.8144 35.3705H19.2097ZM22.7553 31.1567C22.9941 31.1567 23.1994 31.072 23.3712 30.9027C23.5431 30.7335 23.6291 30.5277 23.6291 30.2852V20.9102C23.6291 20.6679 23.5432 20.4611 23.3716 20.2898C23.2001 20.1186 22.9954 20.033 22.7575 20.033C22.515 20.033 22.3081 20.1186 22.1369 20.2898C21.9658 20.4611 21.8803 20.6679 21.8803 20.9102V30.2852C21.8803 30.5277 21.9665 30.7335 22.1387 30.9027C22.311 31.072 22.5166 31.1567 22.7553 31.1567ZM27.2697 31.1567C27.5084 31.1567 27.7137 31.072 27.8856 30.9027C28.0575 30.7335 28.1434 30.5277 28.1434 30.2852V20.9102C28.1434 20.6679 28.0577 20.4611 27.8862 20.2898C27.7146 20.1186 27.5098 20.033 27.2719 20.033C27.0294 20.033 26.8226 20.1186 26.6516 20.2898C26.4803 20.4611 26.3947 20.6679 26.3947 20.9102V30.2852C26.3947 30.5277 26.4808 30.7335 26.6531 30.9027C26.8254 31.072 27.0309 31.1567 27.2697 31.1567Z",
    fill: "#E73C3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteModalIcon);
export default __webpack_public_path__ + "static/media/DeleteModalIcon.d69e286fa86e60e413c3e0182103e0d0.svg";
export { ForwardRef as ReactComponent };